import { render, staticRenderFns } from "./AmountDetailOrder.vue?vue&type=template&id=189538f6&scoped=true"
import script from "./AmountDetailOrder.vue?vue&type=script&lang=ts"
export * from "./AmountDetailOrder.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetailOrder.vue?vue&type=style&index=0&id=189538f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189538f6",
  null
  
)

export default component.exports